'use client'

import _ from 'lodash'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import Link from 'next/link'
import { infoPages } from '@/settings'

export function HeaderInfoMenu() {
  return (
    <Popover as='div' className='relative'>
      {({ close }) =>
        <>
          <PopoverButton className='menu-button font-semibold dark:font-normal'>
            <span>About Us</span>
            <ChevronDownIcon className='size-5 ml-1 -mr-1' />
          </PopoverButton>
          <PopoverPanel anchor='bottom start' transition={true} modal={false} className='menu-items py-2'>
            {
              _.map(infoPages, (page, idx) =>
                <Link hrefLang='en' key={`navInfo_${idx}`} href={page.href} className='menu-item bg-white dark:bg-zinc-800' onClick={close}>
                  {page.name}
                </Link>
              )
            }
          </PopoverPanel>
        </>
      }
    </Popover >
  )
}